import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import PageRoutes from './routes/PageRoutes';
import { BrowserRouter } from 'react-router-dom';
import theme from './theme';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        <BrowserRouter>
          <PageRoutes />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
